import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { ITask } from "../task.interface";
import * as _ from 'lodash';
import { TaskHttpService } from "../task-http.service";
import { TaskCommentService } from "./task-comment.service";
import { AuthService } from "../../../../shared/services/auth.service";
import { Broadcaster } from "../../../../shared/components/broadcaster.component";

let self: any;

@Component({
  selector: 'app-task-comment',
  templateUrl: './task-comment.component.html',
  styleUrls: ['./task-comment.component.css']
})
export class TaskCommentComponent implements OnInit {
  dialog: MatDialogRef<any>;
  uploading = false;
  submitted = false;
  task!: ITask;
  form!: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    public _TaskHttpService: TaskHttpService,
    public _TaskCommentService: TaskCommentService,
    private _AuthService: AuthService,
    private _broadcaster: Broadcaster,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.buildForm();
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      task: [this.task._id],
      comment: [null /*, [Validators.required] */],
      attachments: []
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) return;
    let data: any = _.cloneDeep(this.form.value);
    data.company = this._AuthService.companyId();
    this._TaskCommentService.createComment(data).subscribe((comment: any) => {
      this._broadcaster.broadcast('OnCommentAdded', comment);
      this.dialog.close(comment);
    });
  }

  onUploading() {
    this.uploading = true;
  }

  imagesOnChange(data: any) {
    if (data && data.files) {
      this.form.controls["attachments"].setValue(data.files.map((el: any) => el._id));
    }
    this.uploading = false;
  }
}